import { jsx as _jsx } from "react/jsx-runtime";
import { isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { FormElementStyle } from '../form-element-style';
import { HelpText as HelpTextComponent } from '../help-text/help-text';
const b = bemClassBuilder('v-help-text-list');
export const HelpTextList = observer(props => {
    const helpTexts = props.helpTexts.filter(value => !!value.text);
    if (isEmptyArray(helpTexts))
        return null;
    return (_jsx("div", Object.assign({ className: b.block() }, { children: helpTexts.length === 1 ? (_jsx(HelpTextComponent, { style: FormElementStyle.Error, id: helpTexts[0].id, text: helpTexts[0].text })) : (_jsx("ul", Object.assign({ className: b.element('list') }, { children: helpTexts.map(error => (_jsx("li", { children: _jsx(HelpTextComponent, { style: FormElementStyle.Error, id: error.id, text: error.text }) }, error.id))) }))) })));
});
HelpTextList.displayName = 'HelpTextList';
